<template>
    <div id="app">
        <vue-progress-bar></vue-progress-bar>
        <transition name="fade" mode="out-in">
            <router-view />
        </transition>
    </div>
</template>

<script>
    import event from "plugins/event";

    export default {
        name: "App",
        mounted: function() {
            this.$Progress.finish();
        },
        created: function() {
            this.$Progress.start();
            // eslint-disable-next-line
            this.$router.beforeEach(function(to, from, next) {
                if (to.meta.progress !== undefined) {
                    let meta = to.meta.progress;
                    this.$Progress.parseMeta(meta);
                }
                this.$Progress.start();
                next();
            }.bind(this));
            // eslint-disable-next-line
            this.$router.afterEach(function(to, from) {
                this.$Progress.finish();
            }.bind(this));

            // Add a request interceptor
            this.$http.interceptors.request.use(function(config) {
                if (config.url.endsWith("/last-update") === false) {
                    this.$Progress.start();
                }
                return config;
            }.bind(this), null);

            // Add a response interceptor
            this.$http.interceptors.response.use(null, function (error) {
                this.$Progress.fail();
                let hash;
                try {
                    hash = window.location.hash;
                }
                // eslint-disable-next-line
                catch(e) {}
                // In case of 401 error, we automatically go to login route...
                if (error && error.response && error.response.status === 401 && hash.indexOf("/login") === -1) {
                    return event.$emit("force-logout");
                }
                return Promise.reject(error);
            }.bind(this));
        }
    }
</script>
